import { ReactNode, useMemo } from "react";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { TouchBackend } from "react-dnd-touch-backend";

/**
 * Picks HTML5Backend (mouse / trackpad) or TouchBackend (iPad / phone)
 * at mount time based on `pointer: coarse`. The choice is stable for the
 * lifetime of the floor plan view — switching device profile mid-session
 * requires reload, which is acceptable for kitchen / floor tablets.
 */
export const FloorPlanDndProvider = ({ children }: { children: ReactNode }) => {
  const useTouch = useMemo(() => {
    if (typeof window === "undefined") return false;
    try {
      return window.matchMedia("(pointer: coarse)").matches;
    } catch {
      return "ontouchstart" in window;
    }
  }, []);

  const backend = useTouch ? TouchBackend : HTML5Backend;
  const options = useTouch
    ? {
        enableMouseEvents: false,
        delayTouchStart: 180,         // avoid hijacking scroll
        ignoreContextMenu: true,
        touchSlop: 8,
      }
    : undefined;

  return (
    <DndProvider backend={backend as any} options={options}>
      {children}
    </DndProvider>
  );
};

export const RESERVATION_DRAG_TYPE = "v2-reservation";

export interface ReservationDragItem {
  reservationId: string;
}
